export default {
    log: (value) => {
        console.log(value);
    },
    warn: (value) => {
        console.warn(value);
    },
    display: (value) => {
        console.info(value);
    },
    error: (value) => {
        console.error(value);
    },
    clear: () => {
        console.clear();
    },
};
